import { AccessLevel } from 'constants';

export default {
  isAdmin(userRole) {
    return ['owner', 'admin'].includes(userRole);
  },

  isOwner(userRole) {
    return ['owner'].includes(userRole);
  },

  // Преобразовать права в роль
  privsToAccess(privs) {
    if (privs.sign) return AccessLevel.SIGN;
    if (privs.execute) return AccessLevel.EXECUTE;
    if (privs.modify) return AccessLevel.MODIFY;
    return AccessLevel.VIEW;
  },

  // Преобразовать роли для события в права
  accessToPrivs(access, isOwner) {
    switch (access) {
      case AccessLevel.VIEW:
        return {
          view: true,
          modify: !!isOwner,
          remove: !!isOwner,
          sign: false,
          execute: false,
        };
      case AccessLevel.MODIFY:
        return {
          view: true,
          modify: true,
          remove: !!isOwner,
          sign: false,
          execute: false,
        };
      case AccessLevel.REMOVE:
        return {
          view: true,
          modify: true,
          remove: true,
          sign: false,
          execute: false,
        };
      case AccessLevel.SIGN:
        return {
          view: true,
          modify: !!isOwner,
          remove: !!isOwner,
          sign: true,
          execute: false,
        };
      case AccessLevel.EXECUTE:
        return {
          view: true,
          modify: !!isOwner,
          remove: !!isOwner,
          sign: false,
          execute: true,
        };
      default:
        return {
          view: true,
          modify: false,
          remove: false,
          sign: false,
          execute: false,
        };
    }
  },

  // Преобразовать объект прав пользователя на событие в флаг доступа
  userPrivsToAccess(users) {
    return users.map((i) => {
      const obj = {
        userId: i.userId,
        access: this.privsToAccess(i.privs),
      };
      return obj;
    });
  },

  // даем права на редактирование/подпись для овнера аккаунта
  fixAccOwnerPrivs(access, accOwnerId) {
    return access.map((u) => {
      if (u.userId === accOwnerId) {
        if (!u.privs.execute && !u.privs.sign) {
          u.privs.sign = true;
        }
        u.privs.modify = true;
      }
      return u;
    });
  },

  // получить обновленный массив доступов к объекту
  getManagedAccess(access, actions) {
    const newAccess = [];
    for (const i of actions) {
      const { action, userId, name, avatar, privs } = i;
      if (action === 'create') {
        access.push({ userId, name, avatar, privs });
      } else if (action === 'update') {
        const index = access.findIndex((a) => a.userId === userId);
        if (index !== -1) {
          const rule = access[index];
          access.splice(index, 1, { ...rule, privs });
        }
      } else {
        const index = access.findIndex((a) => a.userId === userId);
        if (index !== -1) {
          access.splice(index, 1);
        }
      }
      newAccess.push({ action, data: { userId, privs } });
    }
    return newAccess;
  },
};
